<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <div>
      <form @submit.prevent="add()" v-on:keypress.enter.prevent="enterKey">
        <div class="row">
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="documentNumber">DNI</label>
              <input type="text" class="form-control generalInput" id="documentNumber"
                v-model.trim.lazy="v$.documentNumber.$model">
              <div v-if="v$.documentNumber.$dirty">
                <small class="form-text text-danger" v-if="v$.documentNumber.$invalid">El
                  formato no es correcto</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="surname">Apellido</label>
              <input type="text" class="form-control generalInput" id="surname" v-model.trim.lazy="v$.surname.$model">
              <div v-if="v$.surname.$dirty">
                <small class="form-text text-danger" v-if="v$.surname.$invalid">El
                  formato no es correcto</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="mobile">Teléfono</label>
              <input type="text" class="form-control generalInput" id="mobile" v-model.trim.lazy="v$.mobile.$model">
              <div v-if="v$.mobile.$dirty">
                <small class="form-text text-danger" v-if="v$.mobile.$invalid">El
                  formato no es correcto</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="email">Email</label>
              <input type="text" class="form-control generalInput" id="email" v-model.trim.lazy="v$.email.$model">
              <div v-if="v$.email.$dirty">
                <small class="form-text text-danger" v-if="v$.email.$invalid">El
                  formato no es correcto</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="street">Calle</label>
              <input type="text" class="form-control generalInput" id="street" v-model.trim.lazy="v$.street.$model"
                :required="number != '' || postalCode != '' || province != '' || city != ''">
              <div v-if="v$.street.$dirty">
                <small class="form-text text-danger" v-if="v$.street.required.$invalid">Campo requerido</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="number">Número</label>
              <input type="text" class="form-control generalInput" id="number" v-model.trim.lazy="v$.number.$model"
                :required="street != '' || postalCode != '' || province != '' || city != ''">
              <div v-if="v$.number.$dirty">
                <small class="form-text text-danger" v-if="v$.number.required.$invalid">Campo requerido</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="postalCode">Código postal</label>
              <input type="text" class="form-control generalInput" id="postalCode"
                v-model.trim.lazy="v$.postalCode.$model"
                :required="number != '' || street != '' || province != '' || city != ''">
              <div v-if="v$.postalCode.$dirty">
                <small class="form-text text-danger" v-if="v$.postalCode.required.$invalid">Campo requerido</small>
                <small class="form-text text-danger" v-if="v$.postalCode.$invalid">El
                  formato no es correcto</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="province">Provincia</label>
              <VueNextSelect class="form-control generalInput" id="province" :options="provincesData" placeholder=""
                close-on-select v-model.trim.lazy="v$.province.$model"></VueNextSelect>
              <input type="text" id="provinceError"
                :required="number != '' || postalCode != '' || street != '' || city != ''" v-model.trim="province">
              <div v-if="v$.province.$dirty">
                <small class="form-text text-danger" v-if="v$.province.required.$invalid">Campo requerido</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="city">Ciudad</label>
              <input type="text" class="form-control generalInput" id="city" v-model.trim.lazy="v$.city.$model"
                :required="number != '' || postalCode != '' || province != '' || street != ''">
              <div v-if="v$.city.$dirty">
                <small class="form-text text-danger" v-if="v$.city.required.$invalid">Campo requerido</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-12 mt-5">
            <div class="h-100 d-flex justify-content-end align-items-end align-content-end">
              <button class="btn generalSecondaryButton" @click="clean()">Limpiar</button>
              <button class="btn btn-primary generalPrimaryButton">Añadir
                registro
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <UserCreate :id="'createRegister'" :modalTitle="'REGISTRO CREADO'" :showFooter="false">
    </UserCreate>
  </Modal>
  <ModalError :id="'modalError'" :modalTitle="'SE HA PRODUCIDO UN ERROR'" :class="'modal'" :showFooter="false"
    :message="errorMessage" :code="errorCode" />
</template>

<script>
import useVuelidate from '@vuelidate/core';
import {
  requiredIf,
  email,
  numeric,
  minLength,
  maxLength
} from '@vuelidate/validators';
import provincias from '../../../../data/provinces.json'
import Modal from '../../Shared/Modal.vue';
import axios from 'axios';
import VueNextSelect from 'vue-next-select'
import UserCreate from './CreateFromBlackList.vue';
import { Modal as ModalBootstrap } from "bootstrap";
import ModalError from '../../Shared/ModalError.vue'

const dniNumber = (value) => {
  if (value != '') {
    var numero, le, letra;
    var expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;

    value = value.toUpperCase();

    if (expresion_regular_dni.test(value) === true) {
      numero = value.substr(0, value.length - 1);
      numero = numero.replace('X', 0);
      numero = numero.replace('Y', 1);
      numero = numero.replace('Z', 2);
      le = value.substr(value.length - 1, 1);
      numero = numero % 23;
      letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
      letra = letra.substring(numero, numero + 1);
      if (letra != le) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  } else {
    return true
  }
}

const alphaAccents = (value) => {
  if (value != '') {
    if (/[a-zA-ZÀ-ÿ\u00f1\u00d1]{2,3}/gi.test(value))
      return true
    else return false
  } else {
    return true
  }
}

export default {
  name: 'AddToBlackList',
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      classes: this.class,
      documentNumber: '',
      street: '',
      mobile: '',
      surname: '',
      email: '',
      number: '',
      postalCode: '',
      city: '',
      province: '',
      provincesData: provincias,
      requiredAddress: false,
      errorMessage: '',
      errorCode: '',
    };
  },
  props: [
    'id',
    'modalTitle',
    'class',
  ],
  validations() {
    return {
      email: {
        email,
      },
      mobile: {
        numeric,
        minLength: minLength(9),
      },
      documentNumber: {
        dniNumber,
      },
      postalCode: {
        numeric,
        maxLength: maxLength(5),
        required: requiredIf(function () {
          if (this.street != '' || this.number != '' || this.city != '' || this.province != '') {
            return true
          } else {
            return false
          }
        }),
      },
      street: {
        required: requiredIf(function () {
          if (this.number != '' || this.postalCode != '' || this.city != '' || this.province != '') {
            return true
          } else {
            return false
          }
        }),
      },
      number: {
        required: requiredIf(function () {
          if (this.street != '' || this.postalCode != '' || this.city != '' || this.province != '') {
            return true
          } else {
            return false
          }
        }),
      },
      city: {
        required: requiredIf(function () {
          if (this.street != '' || this.number != '' || this.postalCode != '' || this.province != '') {
            return true
          } else {
            return false
          }
        }),
      },
      province: {
        required: requiredIf(function () {
          if (this.street != '' || this.number != '' || this.postalCode != '' || this.city != '') {
            return true
          } else {
            return false
          }
        }),
      },
      surname: {
        alphaAccents
      }
    }
  },
  methods: {
    clean() {
      this.documentNumber = '';
      this.street = '';
      this.surname = '';
      this.mobile = '';
      this.email = '';
      this.number = '';
      this.postalCode = '';
      this.city = '';
      this.province = '';
      this.v$.documentNumber.$dirty = false;
      this.v$.surname.$dirty = false;
    },
    add() {
      let bodyToSend = {
        legalIdentifier: this.documentNumber,
        mobile: this.mobile,
        email: this.email,
        surname: this.surname,
        street: this.street,
        number: this.number,
        postalCode: this.postalCode,
        city: this.city,
        province: this.province
      }
      let vacio = true;
      for (let i in bodyToSend) {
        if (bodyToSend[i] != '') {
          vacio = false
          break
        }
      }
      if (!this.v$.$invalid && !vacio) {
        axios.post('/customer/blacklist-save', bodyToSend)
          .then((response) => {
            var myModal = new ModalBootstrap(document.getElementById('createRegister'))
            myModal.show()
            console.log(response);
          })
          .catch((error) => {
            this.errorCode = error.response.data.code
            this.errorMessage = error.response.data.message
            var myModal = new ModalBootstrap(document.getElementById('modalError'))
            myModal.show()
          });
      } else {
        this.v$.$validate
      }
    },
    addressRequired() {
      if (this.street != '' || this.number != '' || this.postalCode != '' || this.city != '' || this.province != '') {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    Modal,
    VueNextSelect,
    UserCreate,
    ModalError
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#provinceError,
#provinceError:focus {
  height: 0px;
  width: 0px;
  border: 0px;
  outline: none;
  margin-left: 100px;
}
</style>
